// src/ride/RideDashboard.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Routes, Route, useNavigate } from "react-router-dom";
import RideSidebar from "./RideSidebar";
import PostRide from "./PostRide";
import MyRides from "./MyRides";
import RideDriverSetup from "../pages/RideDriverSetup";

const API_WRK = process.env.REACT_APP_API_WRK; // e.g., http://localhost:5000/api/worker
const API_BASE = API_WRK?.replace("/api/worker", ""); // ✅ universal base

const RideDashboard = () => {
  const [driverStatus, setDriverStatus] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const workerId = localStorage.getItem("workerId");

  useEffect(() => {
    const checkDriverStatus = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/worker/profile/${workerId}`);
        const dp = res.data?.driverProfile;

        if (dp?.status === "approved") {
          setDriverStatus("approved");
        } else if (dp?.status === "pending") {
          setDriverStatus("pending");
        } else {
          setDriverStatus("incomplete");
        }
      } catch (err) {
        console.error("❌ Error checking driver status:", err);
        setDriverStatus("incomplete");
      } finally {
        setChecking(false);
      }
    };

    if (workerId) checkDriverStatus();
  }, [workerId]);

  if (checking) return <div className="p-6">Checking driver status...</div>;

  // 🚦 Handle incomplete or pending driver setup
  if (driverStatus === "incomplete" || driverStatus === "pending") {
    return <RideDriverSetup />;
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <RideSidebar />
      <div className="flex-1 p-4">
        <Routes>
          <Route path="post" element={<PostRide />} />
          <Route path="my-rides" element={<MyRides />} />
          {/* Future ride-related pages can be added here */}
        </Routes>
      </div>
    </div>
  );
};

export default RideDashboard;
